import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export const CustomizedSelect = (props) => {
  const {
    data,
    value,
    label,
    className,
    onChange,
    hasError,
    errorMessage,
    isRequired,
    isBadgeVisible,
    placeHolder,
    isDisabled,
    ...restProps
  } = props;
  const [isVisited, setIsVisited] = useState(false);
  const [isRequiredInternal, setIsRequiredInternal] = useState(false);

  const handleBlur = (e) => {
    setIsVisited(true);
    if (e.target.value) {
      setIsRequiredInternal(false);
    } else {
      setIsRequiredInternal(isRequired);
    }
  };

  return (
    <div className={cn({ 'form-group': true, active: true, 'has-value': true, required: (isVisited || hasError) && isRequiredInternal && !isDisabled, disabled: isDisabled }, 'selectWrapper')}>
      <label>
        {
          label && (
            <span>
              {label}
              {
                isBadgeVisible && ((isVisited && isRequired) || (hasError && isRequired)) && <em>Required</em>
              }
            </span>
          )
        }
        <select
          onChange={onChange}
          onBlur={handleBlur}
          value={value}
          disabled={isDisabled}
          {...restProps}
        >
          <option value="" disabled>Select...</option>
          {
            data.map((item) => <option key={item.value} value={item.value}>{item.title}</option>)
          }
        </select>
      </label>
    </div>
  );
};

CustomizedSelect.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  placeHolder: PropTypes.string,
  isBadgeVisible: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

CustomizedSelect.defaultProps = {
  className: '',
  hasError: false,
  errorMessage: '',
  label: null,
  name: '',
  value: '',
  isRequired: false,
  placeHolder: 'Select ...',
  isBadgeVisible: true,
  isDisabled: false,
};

export default CustomizedSelect;
